<div aria-hidden="true" class="image-container" [class.is-list]="isList" [style.--cover-url]="'url(' + coverUrl + ')'">
  <img [src]="coverUrl" defaultCover="assets/cover.jpg" loading="lazy">

  <ng-container *ngIf="isList">
    <ng-container *ngFor="let i of listCoverCount; first as isFirst">
      <div *ngIf="isFirst && isList" class="list-cover"></div>
      <div *ngIf="!isFirst" class="list-cover"></div>
    </ng-container>
  </ng-container>

  <div class="icon" *ngIf="showIcon && resolvedIcon && resolvedIcon.icon !== IconFormat.FORMAT_UNDEFINED">
    <opac-icon [icon]="resolvedIcon.icon"></opac-icon>
    <span>{{ resolvedIcon.label | translate }}</span>
  </div>
</div>
